import React from 'react'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import FaqForm from './FaqForm'

import { updateFaq } from '../services'
import { handleError } from '../../../helpers'

export default function EditFaqModal({ visible, onClose, reload, faq }) {
	const { register, handleSubmit, formState: { errors } } = useForm({
		defaultValues: { 
			...faq,
		}
	})

	const onSubmit = values => {
		updateFaq(faq.id, values)
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(error => handleError(error))
	}

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Actualizar Registro</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<FaqForm register={register} errors={errors} faq={faq} />
						<Button color="primary" type="submit">Actualizar Registrar</Button>
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}